/* eslint-disable no-restricted-imports */
import { noop } from 'lodash';
import { MainContainer, ScrollableContainer } from '../../routing/users/CollectionDetails/styles';
import { getIsMobile } from '../../utils/getIsMobile';
import { useBackButton } from '../../utils/useBackButton';
import { DashboardPage } from '../dashboard/DashboardPage';
import { Skeleton } from '../feedback/Skeleton';
import { IconArrowLeft } from '../icon/IconArrowLeft';
import { Box } from '../layout/Box';
import { Flex } from '../layout/Flex';
import { ResizableGrid } from '../layout/ResizableGrid/ResizableGrid';
import { HEADER_BUTTON_WIDTH, SKELETON_CARDS_HEIGHT } from './constants';
import { useHeaderSizes } from './hooks/useHeaderSizes';

const CardSkeleton = ({ height }: { height: number }) => (
    <>
        <Skeleton variant="rect" width="100%" height={height - 24 - 16} borderRadius={2} />
        <Flex direction={'row'} spacing={1} py={1} px={0.5}>
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="text" width={100} height={16} my={0.5} />
        </Flex>
    </>
);

export const CollectionLoading = () => {
    const { headerHeight, headerButtonTop } = useHeaderSizes();
    const { isMobile } = getIsMobile();
    const onNavigateBack = useBackButton();

    const renderItem = (index: number) => <CardSkeleton height={SKELETON_CARDS_HEIGHT[index]} />;

    return (
        <DashboardPage height={{ xs: '100dvh', sm: '100vh' }} gridFeed hideHeader>
            <MainContainer>
                <ScrollableContainer>
                    <Flex
                        px={1}
                        py={headerButtonTop}
                        width="100%"
                        height={headerHeight}
                        direction="row"
                    >
                        <Box width={HEADER_BUTTON_WIDTH} p={1}>
                            <IconArrowLeft
                                color="var(--color-primary)"
                                size={24}
                                onClick={onNavigateBack}
                            />
                        </Box>
                        {!isMobile && isMobile !== null && (
                            <Flex pl={1}>
                                <Skeleton variant="text" width={150} height={28} />
                                <Skeleton variant="text" width={100} height={20} />
                            </Flex>
                        )}
                    </Flex>
                    <Flex
                        px={2}
                        py={1.5}
                        width="100%"
                        height={{ xs: 146, sm: 76 }}
                        direction="column"
                    >
                        {isMobile ? (
                            <Flex height={76} pb={3}>
                                <Skeleton variant="text" width={150} height={28} />
                                <Skeleton variant="text" width={100} height={20} />
                            </Flex>
                        ) : null}
                        <Flex height={76} direction="row" spacing={1.5}>
                            <Skeleton variant="circular" minWidth={48} height={48} />
                            <Flex direction="column">
                                <Skeleton variant="text" width={150} height={24} />
                                <Skeleton variant="text" width={100} height={20} />
                            </Flex>
                        </Flex>
                    </Flex>
                    <Box width="100%" px={{ xs: 1, sm: 2 }} py={{ xs: 1, sm: 2 }}>
                        <ResizableGrid
                            items={Array.from({ length: SKELETON_CARDS_HEIGHT.length }, (_, i) => ({
                                id: String(i),
                            }))}
                            renderItem={renderItem}
                            key={'collection-post-grid-skeleton'}
                            itemsXMargin={4}
                            loadMore={noop}
                            getItemHeight={(index: number) => SKELETON_CARDS_HEIGHT[index]}
                        />
                    </Box>
                </ScrollableContainer>
            </MainContainer>
        </DashboardPage>
    );
};
